import { IPrivilege } from '../interfaces/privilege';

const hasPrivilege = (
  privileges: IPrivilege[] | undefined,
  id?: string
): boolean => {
  if (!id) {
    return true;
  }

  if (!privileges) {
    return false;
  }

  return privileges
    .map((privilege: IPrivilege) => {
      return privilege.code;
    })
    .includes(id);
};

export default hasPrivilege;
